import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.08686 6.8974L0.617187 12.3671L1.67785 13.4277L6.61719 8.48839C7.49587 7.60971 7.49587 6.18509 6.61719 5.30641L1.67785 0.367075L0.617187 1.42773L6.08686 6.8974Z",
		fill: "currentColor"
	})
});
export default SvgChevronRight;
